module.exports = __webpack_public_path__ + "img/168.23cc90fc.gif";